var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        "custom-class": "effect-order-dialog",
        title: "请选择订单",
        "append-to-body": "",
        center: "",
        visible: _vm.visible,
        width: "900px",
        "destroy-on-close": true
      },
      on: {
        "update:visible": function($event) {
          _vm.visible = $event
        },
        close: _vm.hideDialog
      }
    },
    [
      _c(
        "div",
        [
          _c(
            "el-form",
            {
              ref: "searchForm",
              staticClass: "demo-form-inline",
              staticStyle: { "margin-bottom": "10px" },
              attrs: {
                "label-position": "right",
                inline: true,
                model: _vm.searchForm,
                "label-width": "80px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "推送日期", prop: "pushDate" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "240px" },
                    attrs: {
                      type: "daterange",
                      "range-separator": "~",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                      pickerOptions: _vm.pickerOptions
                    },
                    model: {
                      value: _vm.searchForm.pushDate,
                      callback: function($$v) {
                        _vm.$set(_vm.searchForm, "pushDate", $$v)
                      },
                      expression: "searchForm.pushDate"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "要求发货日", prop: "sendDate" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "240px" },
                    attrs: {
                      type: "daterange",
                      "range-separator": "~",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                      pickerOptions: _vm.pickerOptions
                    },
                    model: {
                      value: _vm.searchForm.sendDate,
                      callback: function($$v) {
                        _vm.$set(_vm.searchForm, "sendDate", $$v)
                      },
                      expression: "searchForm.sendDate"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "R0订单号", prop: "main_number" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.searchForm.main_number,
                      callback: function($$v) {
                        _vm.$set(_vm.searchForm, "main_number", $$v)
                      },
                      expression: "searchForm.main_number"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: {
                        background: "#fff",
                        color: "#666",
                        "border-color": "#ccc"
                      },
                      attrs: { type: "primary", size: "small" },
                      on: { click: _vm.resetForm }
                    },
                    [_vm._v("重置\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: {
                        background: "#FF6224",
                        color: "#fff",
                        "border-color": "#FF6224"
                      },
                      attrs: { type: "primary", size: "small" },
                      on: { click: _vm.onSearch }
                    },
                    [_vm._v("查询")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { "padding-top": "8px" } },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading"
                    }
                  ],
                  staticStyle: { width: "100%", "text-align": "center" },
                  attrs: {
                    data: _vm.tableData,
                    size: "mini",
                    "row-key": function(row) {
                      return row.id
                    }
                  },
                  on: {
                    select: _vm.handleSelection,
                    "select-all": _vm.handleSelectAll
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      type: "selection",
                      width: "55",
                      "reserve-selection": true,
                      selectable: _vm.checkSelectable
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "serial_number",
                      label: "编号",
                      width: "100"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "main_number", label: "订单编号" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "created_at", label: "推送日期" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "out_ware_day", label: "要求发货日" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "total_amount", label: "订单总金额" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("div", [
                              _vm._v("￥" + _vm._s(scope.row.total_amount))
                            ])
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "mo_status_str", label: "订单状态" }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("el-pagination", {
            staticStyle: { "text-align": "right" },
            attrs: {
              "current-page": _vm.queryInfo.current,
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.queryInfo.page_size,
              layout: "total,sizes, prev, pager, next,jumper",
              total: _vm.queryInfo.total
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
              "update:currentPage": function($event) {
                return _vm.$set(_vm.queryInfo, "current", $event)
              },
              "update:current-page": function($event) {
                return _vm.$set(_vm.queryInfo, "current", $event)
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "flex-row-center-center",
          staticStyle: { "margin-top": "30px" }
        },
        [
          _c(
            "el-button",
            {
              staticStyle: {
                background: "#fff",
                color: "#666",
                "border-color": "#ccc",
                "margin-right": "16px"
              },
              attrs: { size: "medium" },
              on: { click: _vm.hideDialog }
            },
            [_vm._v("取消\n    ")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "medium" },
              on: { click: _vm.onSubmit }
            },
            [_vm._v("确定")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e76d6a06", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e76d6a06","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/orderReport/reportCenter/components/effectDialog.vue
// module id = null
// module chunks = 